import { useMemo, useRef } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

import { hashToBgColor, pluralize } from '../../../utils/helper';

const MemberTaskItem = ({ eventInfo, onViewDetail }) => {
  const { extendedProps: { member } = {}, title } = eventInfo.event || {};
  const positionRef = useRef({ x: 0, y: 0 });
  const popperRef = useRef(null);
  const areaRef = useRef(null);

  const eventBgColor = useMemo(
    () => hashToBgColor(member?._id) || '#3498DB',
    [member]
  );

  const tooltipContent = useMemo(() => {
    return (
      <Box>
        <Typography>
          <b>{member?.full_name}</b>
        </Typography>
        <Typography>
          <b>Total:</b> {pluralize('hr', member?.work_time_per_day || 0, true)}
        </Typography>
      </Box>
    );
  }, [member]);

  const handleMouseMove = (event) => {
    positionRef.current = { x: event.clientX, y: event.clientY };

    if (popperRef.current != null) {
      popperRef.current.update();
    }
  };

  return (
    <Tooltip
      title={tooltipContent}
      placement="bottom"
      arrow
      PopperProps={{
        popperRef,
        anchorEl: {
          getBoundingClientRect: () => {
            const { y, height } = areaRef.current.getBoundingClientRect();
            return new DOMRect(positionRef.current.x, y + height, 0, 0);
          },
        },
      }}>
      <Box
        sx={{
          padding: '4px',
          cursor: 'pointer',
          backgroundColor: eventBgColor,
        }}
        ref={areaRef}
        onMouseMove={handleMouseMove}
        onClick={onViewDetail}>
        <Typography
          variant="subtitle1"
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontWeight: 600,
          }}>
          {title}
        </Typography>
        <Typography>
          - Total: {pluralize('hr', member?.work_time_per_day || 0, true)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default MemberTaskItem;
